export class OrganizationNumberHelper {
  public static formatOrganizationNumber(orgNumber?: string): string {
    if (!orgNumber) return '';
    return orgNumber.replace(/^(\d{6})(\d+)/, '$1-$2');
  }
}
